import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isModalOpen: false,
  activeTabKey: '1',
  isForgotPassword: false,
  isFromRegister: false,
  isFromLogin: false,
  step: 'initial',
  registeredEmail: '',
  temporaryPassword: null,
  isInitialFlow: false,
  isVideoUploadModalOpen: false,
  isAudioUploadModalOpen: false,
  videoUploadProgress: 0,
  audioUploadProgress: 0,
  isVideoUploading: false,
  isAudioUploading: false,
  isVideoUploadComplete: false,
  isAudioUploadComplete: false,
  isVideoUploadError: false,
  isAudioUploadError: false,
  mediaTypes: [],
  mediaVisibilityOptions: [],
  documentUploadProgress: {},
  isDocumentUploading: false,
  isDocumentUploadComplete: false,
  documentUploadErrors: []
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModalOpen(state, action) {
      state.isModalOpen = action.payload;
    },
    setActiveTabKey(state, action) {
      state.activeTabKey = action.payload;
    },
    setIsForgotPassword(state, action) {
      state.isForgotPassword = action.payload;
    },
    setIsFromRegister(state, action) {
      state.isFromRegister = action.payload;
    },
    setIsFromLogin(state, action) {
      state.isFromLogin = action.payload;
    },
    setStep(state, action) {
      state.step = action.payload;
    },
    setRegisteredEmail(state, action) {
      state.registeredEmail = action.payload;
    },
    setTemporaryPassword(state, action) {
      state.temporaryPassword = action.payload;
    },
    setIsInitialFlow(state, action) {
      state.isInitialFlow = action.payload;
    },
    resetModalState: () => initialState,
    setVideoUploadModalOpen(state, action) {
      state.isVideoUploadModalOpen = action.payload;
    },
    setAudioUploadModalOpen(state, action) {
      state.isAudioUploadModalOpen = action.payload;
    },
    setVideoUploadProgress(state, action) {
      state.videoUploadProgress = action.payload;
    },
    setAudioUploadProgress(state, action) {
      state.audioUploadProgress = action.payload;
    },
    setVideoUploading(state, action) {
      state.isVideoUploading = action.payload;
    },
    setAudioUploading(state, action) {
      state.isAudioUploading = action.payload;
    },
    setVideoUploadComplete(state, action) {
      state.isVideoUploadComplete = action.payload;
    },
    setAudioUploadComplete(state, action) {
      state.isAudioUploadComplete = action.payload;
    },
    setActiveMediaType(state, action) {
      state.activeMediaType = action.payload;
    },
    setVideoUploadError(state, action) {
      state.isVideoUploadError = action.payload;
    },
    setAudioUploadError(state, action) {
      state.isAudioUploadError = action.payload;
    },
    resetVideoUploadState(state) {
      state.isVideoUploading = false;
      state.isVideoUploadComplete = false;
      state.isVideoUploadError = false;
      state.videoUploadProgress = 0;
    },
    resetAudioUploadState(state) {
      state.isAudioUploading = false;
      state.isAudioUploadComplete = false;
      state.isAudioUploadError = false;
      state.audioUploadProgress = 0;
    },
    setMediaTypes(state, action) {
      state.mediaTypes = action.payload;
    },
    setMediaVisibilityOptions(state, action) {
      state.mediaVisibilityOptions = action.payload;
    },
    setDocumentUploading(state, action) {
      state.isDocumentUploading = action.payload;
    },
    setDocumentUploadProgress(state, action) {
      const { uid, progress } = action.payload;
      state.documentUploadProgress[uid] = progress; 
    },
    setDocumentUploadComplete(state, action) {
      state.isDocumentUploadComplete = action.payload;
    },
    setDocumentUploadError(state, action) {
      state.documentUploadErrors.push(action.payload); 
    },
    resetDocumentUploadState(state) {
      state.isDocumentUploading = false;
      state.isDocumentUploadComplete = false;
      state.documentUploadProgress = {};
      state.documentUploadErrors = [];
    }
  }
});

export const {
  setTemporaryPassword,
  setIsForgotPassword,
  setRegisteredEmail,
  setIsFromRegister,
  setIsInitialFlow,
  setActiveTabKey,
  resetModalState,
  setIsFromLogin,
  setModalOpen,
  setStep,
  setVideoUploadModalOpen,
  setAudioUploadModalOpen,
  setVideoUploadProgress,
  setAudioUploadProgress,
  setVideoUploading,
  setAudioUploading,
  setVideoUploadComplete,
  setAudioUploadComplete,
  setActiveMediaType,
  setVideoUploadError,
  setAudioUploadError,
  resetVideoUploadState,
  resetAudioUploadState,
  setMediaTypes,
  setMediaVisibilityOptions,
  setDocumentUploading,
  setDocumentUploadProgress,
  setDocumentUploadComplete,
  setDocumentUploadError,
  resetDocumentUploadState
} = modalSlice.actions;

export default modalSlice.reducer;